import React from 'react';

function EnterIcon(props) {
  return (
    <div className="enter-icon" style={{ display: 'inline-block' }}>
      <ul className="DocSearch-Commands">
        <li>
          <span className="DocSearch-Commands-Key">
            <svg width="15" height="15">
              <g
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.2"
              >
                <path d="M12 3.53088v3c0 1-1 2-2 2H4M7 11.53088l-3-3 3-3"></path>
              </g>
            </svg>
          </span>
        </li>
        <span className="DocSearch-Label">to Insert</span>
      </ul>
    </div>
  );
}

export default EnterIcon;
